<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <incident-reason-create-or-update v-model="incidentReason" :errors="errors"></incident-reason-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
        
        <v-table    ref="table"
                    :buttons="buttons"
                    name="bank-branch"
                    :fields="fields"
                    pagination="server"
                    search
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import IncidentOperationsApi from '@/api/incident-operations'
import IncidentReasonCreateOrUpdate from './components/IncidentReasonCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        IncidentReasonCreateOrUpdate
    },
    data(){
        return {
            fields:[],
            buttons:[],
            incidentReason:{
                Id:null,
                Name:null,
                IsPlateRequired:false
            },
            fields:[
                {name:"Vukuat Türü",key:"Name", thClass:"w-100",sortable:true},   
                {name:"Plaka Gerekli",key:"IsPlateRequired"},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            errors:{},
            editing:false,
            loading:false
        }
    },
    methods:{
        provider(data){
            return IncidentOperationsApi.Reason.Table(data)
        },
        clearForm(){
            this.editing = false
            this.incidentReason.Id = null
            this.incidentReason.Name = null
            this.incidentReason.IsPlateRequired = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.incidentReason.Id = item.Id
            this.incidentReason.Name = item.Name
            this.incidentReason.IsPlateRequired = item.IsPlateRequired
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            IncidentOperationsApi.Reason.CreateOrUpdate(this.editing,this.incidentReason).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem "${item.Name}" vukuat türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    IncidentOperationsApi.Reason.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>